/**
 * Den første importen i `main.tsx`: flytter `chorus.*` til `tvitvi.*` før resten av appen
 * evalueres — før Supabase-klienten lages og før noe leser det aktive huset. Se `legacy-storage.ts`.
 */
import { migrateLegacyStorage } from './legacy-storage';

migrateLegacyStorage();
